import {CircularProgress, Stack} from "@mui/material";
import {useLocation, useNavigate} from "react-router-dom";
import {useContext, useEffect} from "react";
import {toast} from "react-toastify";
import {SignInContext} from "../../../context/SignInContext";
import {AuthLayout} from "../components/AuthLayout";
import {a} from "../components/authStyles";

export const OAuthSuccess = () => {
  const {onOAuth} = useContext(SignInContext);
  const navigate = useNavigate();
  const search = useLocation().search;
  const params = new URLSearchParams(search);
  const token = params.get('token');
  const refreshToken = params.get('refreshToken');
  const error = params.get('error');

  useEffect(() => {
    // Remove the tokens from the address bar and browser history
    window.history.replaceState(null, "", "/oauth2/redirect");

    if (token) {
      const checkIsAuth = async () => {
        try {
          await onOAuth(token, refreshToken);
        } catch (e) {
          toast.error('Failed to authenticate please provide valid token!')
          navigate("/login");
        }
      }
      checkIsAuth();
    } else {
      // On failure the backend sends ?error=<message>, plus &code=ACCOUNT_DISABLED for a deactivated user
      toast.error(error || 'Google login failed, please try again!')
      navigate("/login");
    }
  }, [token])

  return (
    <AuthLayout
      kicker={"Google sign in"}
      title={"Signing you in"}
      description={"Just a moment, we are checking your account."}
    >
      <Stack alignItems={"center"} sx={{py: 1}}>
        <CircularProgress size={28} sx={{color: a.accent}}/>
      </Stack>
    </AuthLayout>
  )
}
